export default __webpack_public_path__ + "static/media/img32.7f81ef51.jpg";